import { useQuery } from "@tanstack/react-query";
import { getFeatures } from "../Api/features";

export const useFeatures = () => {
  return useQuery({
    queryKey: ["features"],
    queryFn: getFeatures,
  });
};
